"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _carpacTable = _interopRequireDefault(require("./components/carpacTable"));
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CarpacTable: _carpacTable.default
  },
  data: function data() {
    return {
      activeTab: 'carpacTab1',
      regionOptions: [],
      rimList: []
    };
  },
  watch: {
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  created: function created() {
    this.getLookupTypeCode();
    this.fetchRegionList();
  },
  methods: {
    fetchRegionList: function fetchRegionList() {
      var _this = this;
      this.$api.reportModule.getProviceCityByRole().then(function (res) {
        _this.regionOptions = res.data || [];
      });
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this2 = this;
      var param = {
        configItemCodeList: ['RIM_SIZE']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var lookupList = JSON.parse(JSON.stringify(res.data || {}));
        _this2.rimList = lookupList['RIM_SIZE'] || [];
      }).catch(function () {
        console.log('Data Request Fail');
      });
    }
  }
};